<div class="innerpage-fullwithbanner clearfix" *ngIf="hasAccess">
  <div class="left">
    <h2 class="bighead">
      Deal Details
      <!--<span class="offerstatus">{{OfferDetailOutputModel.OfferStatus}}</span>-->
    </h2>
    <ul class="bread-crumbs">
      <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
        <a (click)="onHomeBreadCrumbClick();">
          Home
          <span>|</span>
        </a>
      </li>
      <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
      <li><a (click)="Validation.navigateByUrl(breadCrumb_Offers_List);">{{prevPage}}<span>|</span></a></li>
      <li>Deal Details</li>
    </ul>
  </div>
  <!--<div class="right">
      <label class="select breadcumbarea-select bigselect">
          <app-1031-exchange-selector></app-1031-exchange-selector>
      </label>
  </div>-->
</div>
<div class="offredetailspage section-margin" *ngIf="hasAccess">

  <div class="container container-lg min-heightcontainer">

    <div class="border-div clearfix">
      <app-offer-progress-chart [inputOfferGuid]="offerGuid"></app-offer-progress-chart>
    </div>
    <div class="border-div margin0">


      <div class="floatinghead  clearfix">
        <!--<h2 class="mainhead"><span class="text">Offer Details</span></h2>-->


        <h2 class="mainhead">
          <span class="text">Deal details</span>
          <span class="countstyle">{{OfferDetailOutputModel.OfferStatus =='Cancelled' ? 'Canceled' :OfferDetailOutputModel.OfferStatus }}</span>
        </h2>
        <div class="btn-group right-btn rightdropdown margin-bottom-15" *ngIf="OfferDetailOutputModel.IsDraft && (authService.Broker() || authService.Principal() || authService.Principal1031())">
          <button class="right-btn btn  btn-circle btn-green adduserbtn" (click)="onModify();" href="#" placement="top" tooltip="Modify Offer" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
        </div>

        <!--<div class="btn-group right-btn rightdropdown margin-bottom-15" *ngIf="showEditButton && (OfferDetailOutputModel.OfferStatusId==461) && isPrincipal" dropdown>

                      <button id="button-basic" dropdownToggle type="button" class="btn btn-border margin-bottom dropdown-toggle"
                              aria-controls="dropdown-basic">
                          Action <i class="caret"></i>
                      </button>
                      <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                          <li role="menuitem" *ngIf="isShowOfferAccepted"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForCounterAccept(acceptcountertemplate,'panlestyle')">Accept</a></li>
                          <li role="menuitem" *ngIf="isShowCountered"><a class="dropdown-item" href="javascript:void(0);" (click)="viewCounterOffer(offerGuid)">Counter Offer</a></li>
                          <li role="menuitem" *ngIf="isShowRejected"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForCounterReject(rejectcountertemplate,'panlestyle')">Reject</a></li>
                          </ul>
  </div>

                  <div class="btn-group right-btn rightdropdown margin-right-10 margin-bottom-15" dropdown *ngIf="(user.Role=='Broker' || user.Role=='Admin') && showActions && OfferDetailOutputModel.OfferStatusId!=456 && OfferDetailOutputModel.OfferStatusId!=464">
                      <button id="button-basic" dropdownToggle type="button" class="btn btn-border margin-bottom dropdown-toggle"
                              aria-controls="dropdown-basic">
                          Action <i class="caret"></i>
                      </button>
                      <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                          <li role="menuitem" *ngIf="isShowNew"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(451)">New</a></li>
                          <li role="menuitem" *ngIf="isShowOfferAccepted"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForCounterAccept(acceptcountertemplate,'panlestyle')">Accept</a></li>
                          <li role="menuitem" *ngIf="isShowCountered"><a class="dropdown-item" href="javascript:void(0);" (click)="viewCounterOffer(offerGuid)">Counter Offer</a></li>
                          <li role="menuitem" *ngIf="isShowUnderContract"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(455)">Under Contract</a></li>
                          <li role="menuitem" *ngIf="isShowHardContract"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(462)">Hard Contract</a></li>
                          <li role="menuitem" *ngIf="isShowClosed"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(456)">Closed</a></li>

                          <li role="menuitem" *ngIf="isShowCancel"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(466)">Cancel</a></li>

                      </ul>

                  </div>-->
        <span href="javascript:void(0);" tooltip="Download Deal Report" class="btn-border  btn-view-portfolio" (click)="generateReport()" style="cursor:pointer;display:inline-block;height:25px;">
          <i class="fa fa-download" aria-hidden="true"></i>
        </span>
        <div class="btn-group right-btn rightdropdown margin-right-10 margin-bottom-15" dropdown *ngIf="(authService.Broker() || authService.Admin()|| authService.SuperAdmin()) && (!OfferDetailOutputModel.IsDraft)">
          <button id="button-basic" dropdownToggle type="button" class="btn btn-border margin-bottom dropdown-toggle"
                  aria-controls="dropdown-basic">
            Action <i class="caret"></i>
          </button>
          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
            <li role="menuitem" *ngIf="isShowNew"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(451)">New</a></li>
            <li role="menuitem" *ngIf="isShowOfferAccepted"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForCounterAccept(acceptcountertemplate,'panlestyle')">Accept</a></li>
            <li role="menuitem" *ngIf="isShowCountered"><a class="dropdown-item" href="javascript:void(0);" (click)="viewCounterOffer(offerGuid)">Counter Offer</a></li>
            <li role="menuitem" *ngIf="isShowUnderContract"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(455)">Under Contract</a></li>
            <li role="menuitem" *ngIf="isShowHardContract"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(462)">Hard Contract</a></li>
            <li role="menuitem" *ngIf="isShowClosed"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(456)">Closed</a></li>
            <li role="menuitem" *ngIf="isShowCancel"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(466)">Cancel</a></li>
            <li role="menuitem" *ngIf="isShowDeclined"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(467)">Decline</a></li>

          </ul>

        </div>
        <!--<div class="btn-group right-btn rightdropdown margin-right-10 margin-bottom-15" dropdown *ngIf="(authService.Principal()|| authService.Principal1031() || authService.ExternalBroker() || isSellerUser) && (OfferDetailOutputModel.OfferStatusId == 451 || OfferDetailOutputModel.OfferStatusId == 461) && (!OfferDetailOutputModel.IsDraft)">
      <button id="button-basic" dropdownToggle type="button" class="btn btn-border margin-bottom dropdown-toggle"
              aria-controls="dropdown-basic">
          Action <i class="caret"></i>
      </button>
      <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
          <li role="menuitem" *ngIf="isShowNew"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(451)">New</a></li>
          <li role="menuitem" *ngIf="isShowOfferAccepted"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForCounterAccept(acceptcountertemplate,'panlestyle')">Accept</a></li>
          <li role="menuitem" *ngIf="isShowCountered"><a class="dropdown-item" href="javascript:void(0);" (click)="viewCounterOffer(offerGuid)">Counter Offer</a></li>
          <li role="menuitem" *ngIf="isShowUnderContract"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(455)">Under Contract</a></li>
          <li role="menuitem" *ngIf="isShowHardContract"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(462)">Hard Contract</a></li>
          <li role="menuitem" *ngIf="isShowClosed"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(456)">Closed</a></li>
          <li role="menuitem" *ngIf="isShowCancel"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(466)">Cancel</a></li>
          <li role="menuitem" *ngIf="isShowDeclined"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(467)">Decline</a></li>
      </ul>
  </div>-->
        <div class="pull-right" *ngIf="(!authService.Broker() && !authService.Admin()&& !authService.SuperAdmin()) && (OfferDetailOutputModel.OfferStatusId == 466 || OfferDetailOutputModel.OfferStatusId == 467)">
          <!--<p class="fa fa-ban" style="color:red" triggers="mouseenter:mouseleave" popover="Offer is either cancelled or declined"></p>-->
          <i class="fa fa-ban" style="color:red;font-size:18px;" triggers="mouseenter:mouseleave" popover="Offer is either canceled or declined" aria-hidden="true"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" [ngClass]="{'nocontactsin-placeoffer': (propertyDetailForOffer.PrimaryContactName==null && isPrincipal) }">
          <div class="bg-boxes2 border-div propertydetailstop">
            <div class="left">
              <div *ngIf="!OfferDetailOutputModel.IsArchive || (authService.Broker() || authService.Admin()|| authService.SuperAdmin())" class="thumbs2" style="cursor:pointer" routerLink="/viewproperty/{{OfferDetailOutputModel.Slug ? OfferDetailOutputModel.Slug :OfferDetailOutputModel.PropertyGuid}}" [queryParams]="{prevroute:' Details',link:router.url}" [ngStyle]="{'background-image': 'url(' + OfferDetailOutputModel.PropertyImagePath + ')'}"></div>
              <div class="detailsdiv" *ngIf="!OfferDetailOutputModel.IsArchive || (authService.Broker() || authService.Admin()|| authService.SuperAdmin())">
                <h4 style="cursor:pointer" routerLink="/viewproperty/{{OfferDetailOutputModel.Slug ? OfferDetailOutputModel.Slug :OfferDetailOutputModel.PropertyGuid}}" [queryParams]="{prevroute:'Deal Details',link:router.url}" popover="{{OfferDetailOutputModel.PropertyName}}" placement="top" container="body" triggers="mouseenter:mouseleave"> {{OfferDetailOutputModel.PropertyName}}</h4>
                <h5 class="">
                  <span tooltip="{{OfferDetailOutputModel.PropertyType}}">{{commonService.GetPropertyTypeWithCount(OfferDetailOutputModel.PropertyType)}}</span>
                  <!--<span class="status green">fgdgdfg</span>-->
                </h5>

              </div>

              <div *ngIf="OfferDetailOutputModel.IsArchive && !authService.Broker() && !authService.Admin()&& !authService.SuperAdmin()" class="thumbs2" style="cursor:pointer" (click)="archivepropertyMessage()" [ngStyle]="{'background-image': 'url(' + OfferDetailOutputModel.PropertyImagePath + ')'}"></div>
              <div class="detailsdiv" *ngIf="OfferDetailOutputModel.IsArchive && !authService.Broker() && !authService.Admin()&& !authService.SuperAdmin()">
                <h4 style="cursor:pointer"  (click)="archivepropertyMessage()" popover="{{OfferDetailOutputModel.PropertyName}}" placement="top" container="body" triggers="mouseenter:mouseleave"> {{OfferDetailOutputModel.PropertyName}}</h4>
                <h5 class="">
                  <span tooltip="{{OfferDetailOutputModel.PropertyType}}">{{commonService.GetPropertyTypeWithCount(OfferDetailOutputModel.PropertyType)}}</span>
                  <!--<span class="status green">fgdgdfg</span>-->
                </h5>

              </div>
              <div class="clearfix"></div>
            </div>
            <div class="right">
              <ul>
                <li>
                  <h5>Asking Price</h5>
                  <h6 *ngIf="OfferDetailOutputModel.Unpriced">Unpriced</h6>
                  <h6 *ngIf="!OfferDetailOutputModel.Unpriced"> {{Validation.IsNullAndAddPrefix(OfferDetailOutputModel.AskingPrice|number,'','$ ') == ''?'-':Validation.IsNullAndAddPrefix(OfferDetailOutputModel.AskingPrice|number,'','$ ')}}</h6>
                </li>

                <li>
                  <h5>CAP Rate</h5>
                  <h6 *ngIf="OfferDetailOutputModel.CharacteristicsId == 1">ZCF</h6>

                  <h6 *ngIf="OfferDetailOutputModel.CharacteristicsId != 1">{{Validation.IsNullAndAddSuffix(OfferDetailOutputModel.CapRate|number,'',' %') == '' ? '-' :Validation.IsNullAndAddSuffix(OfferDetailOutputModel.CapRate|number,'',' %')}}</h6>
                </li>
                <li>
                  <h5>Rating</h5>
                  <h6>{{OfferDetailOutputModel.Rating == '' ? '-': OfferDetailOutputModel.Rating}}</h6>
                </li>
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 property-contact" *ngIf="!isPrincipal">
          <div class="bg-boxes2 border-div">
            <ul class="contacts">

              <li class="clearfix">

                <div class="imgblock" [ngStyle]="{'background-image': 'url(' + OfferDetailOutputModel.ProfilePicPath + ')'}">
                </div>
                <div class="data">
                  <h3>{{OfferDetailOutputModel.PrincipalName}} <span style="color:gray" *ngIf="!OfferDetailOutputModel.IsUseBuyerDetail">{{showBuyerInfoIfAny()}}</span><span> - {{OfferDetailOutputModel.OfferForExtBroker ? 'Broker' : 'Buyer'}}</span></h3>

                  <!--<h3>{{OfferDetailOutputModel.IsUseBuyerDetail == false ? OfferDetailOutputModel.PrincipalName : showBuyerInfoIfAny()}} <span style="color:gray" *ngIf="!OfferDetailOutputModel.IsUseBuyerDetail">{{showBuyerInfoIfAny()}}</span><span> - {{OfferDetailOutputModel.OfferForExtBroker ? 'Broker' : 'Buyer'}}</span></h3>-->
                  <p *ngIf="OfferDetailOutputModel.IsUseBuyerDetail == false && OfferDetailOutputModel.PhoneNo != null">
                    <i class="icon-phone icon"></i>{{ OfferDetailOutputModel.IsUseBuyerDetail == false ? (OfferDetailOutputModel.PhoneNo | phone) : (OfferDetailOutputModel.BuyerPhone | phone) }}
                  </p>

                  <p *ngIf="OfferDetailOutputModel.IsUseBuyerDetail != false && OfferDetailOutputModel.BuyerPhone != null">
                    <i class="icon-phone icon"></i>{{ OfferDetailOutputModel.IsUseBuyerDetail == false ? (OfferDetailOutputModel.PhoneNo | phone) : (OfferDetailOutputModel.BuyerPhone | phone) }}
                  </p>
                  <p *ngIf="OfferDetailOutputModel.Email">
                    <i class="icon-message icon"></i>
                    <a href="mailto:{{OfferDetailOutputModel.Email}}">{{OfferDetailOutputModel.Email}}</a>
                  </p>

                </div>

              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 property-contact" *ngIf="propertyDetailForOffer.PrimaryContactName!=null && isPrincipal">
          <div class="bg-boxes2 border-div">
            <ul class="contacts">

              <li class="clearfix">

                <div class="imgblock" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.PrimaryContactImagePath + ')'}">
                </div>
                <div class="data">
                  <h3>{{propertyDetailForOffer.PrimaryContactName!=null?((propertyDetailForOffer.PrimaryContactName)):'-'}} <span>- {{propertyDetailForOffer.PrimaryContactRole}}</span></h3>
                  <p>
                    <i class="icon-phone icon"></i>{{propertyDetailForOffer.PrimaryContactPhone!=null?(propertyDetailForOffer.PrimaryContactPhone | phone):'-'}}
                  </p>
                  <p>
                    <i class="icon-message icon"></i>
                    <a href="#">{{propertyDetailForOffer.PrimaryContactEmail!=null?(propertyDetailForOffer.PrimaryContactEmail):'-'}}</a>
                  </p>

                </div>

              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-12" style="margin-bottom:10px" *ngIf="OfferDetailOutputModel.IsPortfolio">
          <app-portfolio-property-list [leadDetailsGuid]="offerGuid" [Isunpriced]="OfferDetailOutputModel.Unpriced?'1':0" [Iszcf]="OfferDetailOutputModel.CharacteristicsId == 1?'1':'0'"></app-portfolio-property-list>
        </div>

      </div>


      <div class="tabstyle2 offerdetailstab-padding" [class]="classToBind">
        <tabset>
          <tab heading="Details" [active]="openTab === 'details'" (select)="changeTitle($event,'details')"><app-offer-detail-tab [inputOfferGuid]="offerGuid"></app-offer-detail-tab></tab>
          <tab heading="Tasks" [active]="openTab === 'tasks'" (select)="changeTitle($event,'tasks')">  <app-offer-task-list (showBadge)="showBadge($event)" [inputOfferGuid]="offerGuid"></app-offer-task-list></tab>
          <tab heading="Progress" [active]="openTab === 'progress'" (select)="changeTitle($event,'progress')"><div class="clearfix"><app-offer-progress-tab [inputOfferGuid]="offerGuid"></app-offer-progress-tab></div></tab>
          <tab heading="Files" [active]="openTab === 'files'" (select)="changeTitle($event,'files')"><app-offer-files-tab [inputOfferGuid]="offerGuid" [RefreshTab] ="'Offer-Files'" [fileTypes]="fileTypes"></app-offer-files-tab></tab>
          <tab heading="Expenses" [active]="openTab === 'expenses'" (select)="changeTitle($event,'expenses')"><app-offer-expense-list [inputOfferGuid]="offerGuid"></app-offer-expense-list></tab>
        </tabset>
      </div>
    </div>
  </div>
</div>

<ng-template #acceptcountertemplate>
  <app-offer-status-change (close)="closeModal" [modalRef]="modalRef" [offerGuid]="offerGuid" [showAccept]="showAccept" (acceptedOffer)="offerAccepted($event)"></app-offer-status-change>
</ng-template>

<ng-template #rejectcountertemplate>
  <app-offer-status-change (close)="closeModal" [modalRef]="modalRef" [offerGuid]="offerGuid" [showAccept]="showAccept"></app-offer-status-change>
</ng-template>
